import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getApiUrl } from '../config/api';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Establecer título de la página
  useEffect(() => {
    document.title = "Botomatic - Login";
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    
    try {
      const res = await fetch(getApiUrl("/auth/public/signin"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      
      if (!res.ok) {
        const data = await res.json();
        setError(data.message || "Credenciales incorrectas");
        return;
      }
      
      const data = await res.json();
      // El access y el refresh token viajan en cookies httpOnly que emite el
      // backend; JavaScript no los toca. Solo guardamos el marcador no sensible
      // de sesión (roles) y el nombre para la UI.
      localStorage.setItem("userRoles", JSON.stringify(data.roles || []));
      localStorage.setItem("username", data.username || "");
      
      // Redirigir al dashboard después del login exitoso
      setTimeout(() => {
        navigate("/dashboard", { replace: true });
      }, 500);
      
    } catch (err) {
      setError("Error de red o del servidor");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="auth-logo">
        <img src="/botomatic_icon.png" alt="Botomatic Logo" />
      </div>
      <div className="auth-container">
        <h2>Iniciar sesión</h2>
        <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={isLoading}
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={isLoading}
        />
        <button type="submit" disabled={isLoading}>
          {isLoading ? "Iniciando sesión..." : "Iniciar sesión"}
        </button>
        {error && <div className="error">{error}</div>}
      </form>
      {/* <div className="switch-link">
        ¿No tienes cuenta? <button type="button" onClick={() => navigate("/register")}>Regístrate</button>
      </div> */}
      </div>
    </>
  );
}

export default Login;
